import { ListContainer } from '@/app/common/components/Base/styled.ts';

type Props = {
  direction: 'row' | 'column';
  columns?: number;
  rows?: number;
  gap?: number;
  columnGap?: number;
  style?: React.CSSProperties;
  as?: string;
  children: React.ReactNode;
};

const List = ({ direction, columns, rows, gap, columnGap, as, children, style }: Props) => (
  <ListContainer
    direction={direction}
    gap={gap}
    columnGap={columnGap}
    columns={columns}
    rows={rows}
    as={as}
    style={style}
  >
    {children}
  </ListContainer>
);

export const Row = ({ columns = 1, gap = 16, style = {}, children }: Omit<Props, 'direction'>) => (
  <List direction="row" gap={gap} columns={columns} style={style}>
    {children}
  </List>
);

export const Column = ({ columns = 1, rows, gap = 16, columnGap, as, children }: Omit<Props, 'direction'>) => (
  <List direction="column" gap={gap} columnGap={columnGap} columns={columns} rows={rows} as={as}>
    {children}
  </List>
);

export default List;
